import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addError } from 'actions'
import { browserHistory } from 'react-router'
import CandidateServices from 'interview/services/candidate'
import FinishedComponent from 'interview/components/finished'

const mapStateToProps = state => ({
  showSurvey: state.interview.jobOpening.company.showSurvey,
  interview: state.interview.jobOpening,
  candidate: state.candidate,
})

const propTypes = {
  showSurvey: PropTypes.bool,
  interview: PropTypes.shape({
    _id: PropTypes.string,
    type: PropTypes.string,
    company: PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  candidate: PropTypes.shape({
    uuid: PropTypes.string,
  }).isRequired,
}

const defaultProps = {
  showSurvey: false,
}

export class Finished extends Component {
  constructor(props) {
    super(props)

    this.onReopenInterview = this.onReopenInterview.bind(this)
  }

  onReopenInterview() {
    const {
      candidate: { uuid },
      dispatch,
    } = this.props

    return CandidateServices.reopenInterview(uuid)
      .then(() => {
        browserHistory.push(`/enter/${uuid}/`)
      })
      .catch(err => {
        dispatch(addError(err))
      })
  }

  render() {
    const { interview, candidate, showSurvey } = this.props
    return (
      <FinishedComponent
        interview={interview}
        candidate={candidate}
        showSurvey={showSurvey}
        onReopenInterview={this.onReopenInterview}
      />
    )
  }
}

Finished.propTypes = propTypes
Finished.defaultProps = defaultProps

export default connect(mapStateToProps)(Finished)
